$( document ).on('turbolinks:load', function() {
  if($('body').hasClass('webhook_notifications')) {
    $('#webhook_notification_messages').on('cocoon:before-insert', function(e, insertedItem, originalEvent) {
      select = $(insertedItem).find('select')[0]
      $(select).on('change', '', function (e) {
        checkSelect(this)
      });
    });

    $('#webhook_notification_messages').on('cocoon:after-insert', function(e, insertedItem, originalEvent) {
      var requestedType = $('#webhook_notification_messages').data('pending-message-type');
      if(requestedType){
        $(insertedItem).find('.message_type').val(String(requestedType)).trigger('change');
        $('#webhook_notification_messages').removeData('pending-message-type');
      }
      $('.webhook-flow-list').append(insertedItem);
      refreshWebhookFlow();
      if($('.row_webhook_notification_message_fields').not('[style*="display: none"]').length >= 10){
        $('.add_webhook_notification_message_fields').hide()
      }
    });

    $('#webhook_notification_messages').on('cocoon:after-remove', function(e, insertedItem, originalEvent) {
      refreshWebhookFlow();
      if($('.row_webhook_notification_message_fields').not('[style*="display: none"]').length < 10){
        $('.add_webhook_notification_message_fields').show()
      }
    });

    $('.row_webhook_notification_message_fields').on('change', '', function (e) {
      select = $(this).find('select')[0]
      checkSelect(select)
    });

    $('.row_webhook_notification_message_fields').each(function(index, value) {
      select = $(value).find('select')[0]
      checkSelect(select)
    });

    if($('.row_webhook_notification_message_fields').not('[style*="display: none"]').length < 10){
      $('.add_webhook_notification_message_fields').show()
    }

    $(document).off('click.webhookFlow').on('click.webhookFlow', '.webhook-flow-add', function(){
      if(activeWebhookBlocks().length >= 10) return;
      $('#webhook_notification_messages').data('pending-message-type', $(this).data('message-type'));
      $('.add_webhook_notification_message_fields .add_fields').first().trigger('click');
    });
    initWebhookFlowDrag();
    refreshWebhookFlow();
  }
})

function activeWebhookBlocks(){
  return $('.webhook-flow-list .webhook-flow-block').filter(function(){ return $(this).css('display') !== 'none'; });
}

function refreshWebhookFlow(){
  var blocks = activeWebhookBlocks();
  blocks.each(function(index){
    $(this).find('.webhook-message-position').val(index);
    var type = $(this).find('.message_type option:selected').text() || 'Mensagem';
    var delay = $(this).find('input[name*="[time_after]"]').val();
    $(this).find('.webhook-flow-title').text((index + 1) + '. ' + type);
    $(this).find('.webhook-flow-delay').text(delay ? formatWebhookDelay(delay) : 'imediatamente');
  });
  $('.webhook-flow-canvas').toggleClass('is-empty', blocks.length === 0);
  $('.webhook-flow-add').prop('disabled', blocks.length >= 10);
}

function formatWebhookDelay(value){
  var totalSeconds = parseInt(value, 10);
  if(!Number.isFinite(totalSeconds) || totalSeconds <= 0) return 'imediatamente';

  var remaining = totalSeconds;
  var units = [
    { seconds: 86400, singular: 'dia', plural: 'dias' },
    { seconds: 3600, singular: 'hora', plural: 'horas' },
    { seconds: 60, singular: 'minuto', plural: 'minutos' }
  ];
  var readable = [];

  units.forEach(function(unit){
    var amount = Math.floor(remaining / unit.seconds);
    if(amount > 0){
      readable.push(amount + ' ' + (amount === 1 ? unit.singular : unit.plural));
      remaining %= unit.seconds;
    }
  });
  if(remaining > 0 && readable.length < 2){
    readable.push(remaining + ' ' + (remaining === 1 ? 'segundo' : 'segundos'));
  }

  var rawUnit = totalSeconds === 1 ? 'segundo' : 'segundos';
  return 'após ' + totalSeconds + ' ' + rawUnit + (readable.length ? ' · ' + readable.slice(0, 2).join(' e ') : '');
}

function initWebhookFlowDrag(){
  var dragged = null;
  $(document).off('.webhookFlowDrag')
    .on('mousedown.webhookFlowDrag touchstart.webhookFlowDrag', '.webhook-flow-block-heading', function(){ $(this).closest('.webhook-flow-block').attr('draggable', 'true'); })
    .on('dragstart.webhookFlowDrag', '.webhook-flow-block', function(e){
      dragged = this;
      $(this).addClass('is-dragging');
      e.originalEvent.dataTransfer.effectAllowed = 'move';
      e.originalEvent.dataTransfer.setData('text/plain', 'webhook-message');
    })
    .on('dragover.webhookFlowDrag', '.webhook-flow-list', function(e){
      if(!dragged) return;
      e.preventDefault();
      e.originalEvent.dataTransfer.dropEffect = 'move';

      var pointerY = e.originalEvent.clientY;
      var nextBlock = activeWebhookBlocks().not(dragged).filter(function(){
        var rect = this.getBoundingClientRect();
        return pointerY < rect.top + rect.height / 2;
      }).first();

      if(nextBlock.length){
        if(dragged.nextElementSibling !== nextBlock[0]) nextBlock.before(dragged);
      }else if(this.lastElementChild !== dragged){
        $(this).append(dragged);
      }
    })
    .on('drop.webhookFlowDrag', '.webhook-flow-list', function(e){
      if(!dragged) return;
      e.preventDefault();
      refreshWebhookFlow();
    })
    .on('dragend.webhookFlowDrag', '.webhook-flow-block', function(){ $(this).removeClass('is-dragging').attr('draggable','false'); $('.drag-over').removeClass('drag-over'); dragged=null; refreshWebhookFlow(); })
    .on('change.webhookFlowDrag input.webhookFlowDrag', '.message_type, input[name*="[time_after]"]', refreshWebhookFlow);
}

function checkSelect(select){
  if($(select).val() == '1'){
    $(select).parent().next().next().next().next().not('.field-official-api').not('.field-pixel-block').show()
  }else if($(select).val() == '2' || $(select).val() == '3' || $(select).val() == '15' || $(select).val() == '4' || $(select).val() == '5' || $(select).val() == '12'){
    $(select).parent().next().next().next().not('.field-official-api').not('.field-pixel-block').show()
    if($(select).val() == '2' || $(select).val() == '12'){
      $($(select).parent().next().next().next().find('input')[0]).attr("accept", '.png, .jpg, .jpeg')
    }else if($(select).val() == '3' || $(select).val() == '15'){
      $($(select).parent().next().next().next().find('input')[0]).attr("accept", '.mp4, video/mp4')
    }else if($(select).val() == '4'){
      $($(select).parent().next().next().next().find('input')[0]).attr("accept", 'audio/*')
    }else if($(select).val() == '5'){
      $($(select).parent().next().next().next().find('input')[0]).attr("accept", '.pdf')
    }
  }else{
    $(select).parent().next().next().next().hide()
  }
}
